import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=29c84cf0"
import script from "./PaymentInfo.vue?vue&type=script&lang=ts"
export * from "./PaymentInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports